export default {
  authenticated: false,
  managed_sps: [],
  selected_sp: {},
  user: {},
};



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/state.js